import React from 'react'

import SubscriptionsPayment from '@/screens/Subscriptions/Payment'

function AccountEditPlanPayment(): React.ReactElement {
  return <SubscriptionsPayment />
}

export default React.memo(AccountEditPlanPayment)
